import { ContentBlock } from '@examdojo/study-notes';
import { LearningContentAction } from './solver.model';

export function applyLearningContentActions(content: ContentBlock[], actions: LearningContentAction[]): ContentBlock[] {
  let newContent = [...content];

  for (const action of actions) {
    switch (action.type) {
      case 'add_items':
        if (action.position === 'start') {
          newContent.unshift(...action.items);
        } else {
          newContent.push(...action.items);
        }
        break;
      case 'insert_items': {
        const index = newContent.findIndex((item) => item.id === action.after_id);
        if (index !== -1) {
          newContent.splice(index + 1, 0, ...action.items);
        }
        break;
      }
      case 'remove_items':
        newContent = newContent.filter((item) => !action.item_ids.includes(item.id));
        break;
      case 'replace_item': {
        const replaceIndex = newContent.findIndex((item) => item.id === action.item_id);
        if (replaceIndex !== -1) {
          newContent[replaceIndex] = action.new_item;
        }
        break;
      }
    }
  }
  return newContent;
}
